var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Calendar from '../Calendar/Calendar';
import DateFieldInput from '../DateFieldInput/DateFieldInput';
var DateFieldSingle = function (_a) {
    var _b = _a.disableWeekend, disableWeekend = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, inputWrapperRef = _a.inputWrapperRef, maxDate = _a.maxDate, minDate = _a.minDate, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, _d = _a.picker, picker = _d === void 0 ? 'date' : _d, _e = _a.range, range = _e === void 0 ? null : _e, _f = _a.readOnly, readOnly = _f === void 0 ? false : _f, _g = _a.selected, selected = _g === void 0 ? null : _g, setShowCalendar = _a.setShowCalendar, showCalendar = _a.showCalendar, warningDatesMessage = _a.warningDatesMessage;
    var onSelectCalendarDate = function (date) {
        onChange(date);
        onCloseCalendar();
    };
    var onOpenCalendar = function () {
        if (disabled || readOnly) {
            return;
        }
        setShowCalendar(true);
    };
    var onCloseCalendar = function () {
        setShowCalendar(false);
    };
    return (_jsx(DateFieldInput, __assign({ picker: picker, selectsRange: false, closeCalendar: onCloseCalendar, openCalendar: onOpenCalendar, disabled: disabled, readOnly: readOnly, onChange: function (newDate) { return onChange(newDate); }, disableWeekend: disableWeekend, minDate: minDate, maxDate: maxDate, onBlur: onBlur, onFocus: onFocus, range: range, selected: selected }, { children: showCalendar && (_jsx(Calendar, { value: selected, onChange: function (value) { return onSelectCalendarDate(value); }, isRange: false, maxDate: maxDate, minDate: minDate, disableWeekend: disableWeekend, inputRef: inputWrapperRef, picker: picker, warningDatesMessage: warningDatesMessage })) })));
};
export default DateFieldSingle;
